var _defs, _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _ellipse2, _ellipse3, _circle, _circle2, _circle3, _circle4, _circle5, _line, _line2, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 164",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky-a",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a2a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#2d3a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#7a4010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c06010"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sun-a",
    cx: "50%",
    cy: "72%",
    r: "35%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffd060",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#e08020",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#7a4010",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a2a3a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ember-core",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#ff9020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c04000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ridge-a",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0d1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#050d0d"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 164,
    fill: "url(#sky-a)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 118,
    rx: 80,
    ry: 30,
    fill: "url(#sun-a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 140 Q30 120 60 128 Q80 118 100 122 Q120 116 145 124 Q165 118 200 130 L200 164 L0 164Z",
    fill: "url(#ridge-a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 155 Q40 145 80 150 Q120 144 160 148 Q180 146 200 150 L200 164 L0 164Z",
    fill: "#060e0e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 60 Q90 58 92 57 L94 55 Q96 53 100 52 Q104 53 106 55 L108 57 Q110 58 112 60 L114 70 Q112 80 110 90 Q108 100 107 110 L100 114 L93 110 Q92 100 90 90 Q88 80 86 70Z",
    fill: "#1a1008"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 60 Q84 62 82 66 L80 74 Q82 78 86 80 L90 82 Q92 84 92 88 L90 96 Q88 102 88 108 L93 112 Q92 102 90 94 Q90 88 92 84 L88 80 Q84 76 83 72 L85 64Z",
    fill: "#120c04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112 60 Q116 62 118 66 L120 74 Q118 78 114 80 L110 82 Q108 84 108 88 L110 96 Q112 102 112 108 L107 112 Q108 102 110 94 Q110 88 108 84 L112 80 Q116 76 117 72 L115 64Z",
    fill: "#120c04"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 82,
    rx: 6,
    ry: 6,
    fill: "url(#ember-core)",
    opacity: 0.95
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 82,
    rx: 3,
    ry: 3,
    fill: "#fff8e0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 74,
    r: 1.2,
    fill: "#ffb030",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 70,
    r: 0.9,
    fill: "#ffd060",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 66,
    r: 0.7,
    fill: "#ff9020",
    opacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 63,
    r: 0.5,
    fill: "#ffb030",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 60,
    r: 0.6,
    fill: "#ffd060",
    opacity: 0.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 74,
    x2: 94,
    y2: 68,
    stroke: "#ffb030",
    strokeWidth: 0.4,
    opacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 70,
    x2: 103,
    y2: 64,
    stroke: "#ffd060",
    strokeWidth: 0.4,
    opacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80 Q82 78 80 80 Q82 84 86 84Z",
    fill: "#2a1804",
    opacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114 80 Q118 78 120 80 Q118 84 114 84Z",
    fill: "#2a1804",
    opacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56 Q74 52 68 50 Q72 56 70 62 Q74 58 78 56Z",
    fill: "#1a0e04",
    opacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122 56 Q126 52 132 50 Q128 56 130 62 Q126 58 122 56Z",
    fill: "#1a0e04",
    opacity: 0.4
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30 95 Q50 85 30 75 Q20 80 22 90Z",
    fill: "#0a1010",
    opacity: 0.6
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M155 90 Q170 82 158 72 Q150 78 152 88Z",
    fill: "#0a1010",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.74c9ba5b767b16f93ea85a2e2ff1a3cb.svg";
export { ForwardRef as ReactComponent };